import { render, staticRenderFns } from "./OptionSellClient.vue?vue&type=template&id=2f95d0ac&scoped=true&"
import script from "./OptionSellClient.vue?vue&type=script&lang=ts&"
export * from "./OptionSellClient.vue?vue&type=script&lang=ts&"
import style0 from "./OptionSellClient.vue?vue&type=style&index=0&id=2f95d0ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f95d0ac",
  null
  
)

export default component.exports